"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typography = require("../tokens/typography");
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _AnimationsUtil = require("../tokens/AnimationsUtil");
var _commonHelper = require("../helpers/commonHelper");
var _H = _interopRequireDefault(require("../Typography/Heading/H2"));
var _uniqueIdHelper = _interopRequireDefault(require("../helpers/uniqueIdHelper"));
var _excluded = ["children", "alignLinks", "additionalGap", "bottomBorder", "appearance", "large", "hasThinLine", "floatBottom"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HorizontalTabs = function HorizontalTabs(_ref) {
  var children = _ref.children,
    alignLinks = _ref.alignLinks,
    additionalGap = _ref.additionalGap,
    bottomBorder = _ref.bottomBorder,
    appearance = _ref.appearance,
    large = _ref.large,
    hasThinLine = _ref.hasThinLine,
    floatBottom = _ref.floatBottom,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var uniqueId = (0, _uniqueIdHelper["default"])("TabLink");
  return /*#__PURE__*/_react["default"].createElement(HorizontalTabs.container, (0, _extends2["default"])({
    appearance: appearance,
    large: large
  }, props), /*#__PURE__*/_react["default"].createElement(HorizontalTabs.Wrapper, {
    floatBottom: floatBottom,
    align: alignLinks,
    role: "tablist"
  }, _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      gap: additionalGap,
      appearance: appearance,
      id: "".concat(uniqueId, "__").concat(index),
      key: "Key_TabLink__".concat(index)
    });
  }), bottomBorder && /*#__PURE__*/_react["default"].createElement(HorizontalTabs.bottomBorder, {
    className: "bottom-border",
    hasThinLine: hasThinLine
  })));
};
HorizontalTabs.container = _styledComponents["default"].section.withConfig({
  componentId: "sc-1y3q50z-0"
})(["width:100%;max-width:", "rem;overflow-y:hidden;overflow-x:auto;overflow:-moz-scrollbars-none;-ms-overflow-style:none;::-webkit-scrollbar{display:none;}min-height:", ";position:relative;"], function (props) {
  return props.large ? 110 : 90;
}, function (props) {
  return props.appearance === "bold" ? "7.4rem" : "6.2rem";
});
var positionAtBottom = /*#__PURE__*/(0, _styledComponents.css)(["position:absolute;bottom:0;left:0;"]);
HorizontalTabs.Wrapper = _styledComponents["default"].section.attrs(function (_ref2) {
  var align = _ref2.align;
  var mapper = {
    left: "flex-start",
    right: "flex-end",
    center: "center",
    even: "space-between"
  };
  return {
    align: mapper[align] || "center"
  };
}).withConfig({
  componentId: "sc-1y3q50z-1"
})(["width:max-content;min-width:100%;display:flex;position:relative;justify-content:", ";background-color:transparent;margin-right:", ";overflow:-moz-scrollbars-none;overflow-x:auto;-ms-overflow-style:none;::-webkit-scrollbar{display:none;}:last-child{margin-right:0;padding-right:0;}:first-child{margin-left:0;padding-left:0;}", ""], function (props) {
  return props.align;
}, function (props) {
  return props.gap;
}, function (_ref3) {
  var floatBottom = _ref3.floatBottom;
  return floatBottom && positionAtBottom;
});
HorizontalTabs.bottomBorder = _styledComponents["default"].hr.withConfig({
  componentId: "sc-1y3q50z-2"
})(["width:calc(100% - 2px);height:0rem;border-top:", "px solid ", ";border-bottom:none;bottom:1px;left:0;margin:0;padding:0;position:absolute;@media screen and (min-width:768px){min-width:calc(100% - 2px);}"], function (props) {
  return props.hasThinLine ? 1 : 2;
}, _grey["default"].z300);
HorizontalTabs.Link = function (props) {
  var onClick = props.onClick,
    active = props.active,
    gap = props.gap,
    appearance = props.appearance,
    isSpaced = props.isSpaced;
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    event.target.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    });
    onClick(event);
  };
  return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({}, props, {
    tabIndex: 0,
    onClick: handleClick,
    onKeyDown: (0, _commonHelper.onKeySelect)(handleClick),
    role: "tab",
    gap: gap
  }), /*#__PURE__*/_react["default"].createElement(HorizontalTabs.LinkEle, (0, _extends2["default"])({}, props, {
    tabIndex: -1,
    onClick: handleClick,
    onKeyDown: (0, _commonHelper.onKeySelect)(handleClick),
    appearance: appearance,
    isSpaced: isSpaced
  }), props.children), /*#__PURE__*/_react["default"].createElement(Bar, {
    active: active,
    isSpaced: isSpaced
  }));
};
var Wrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1y3q50z-3"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;max-height:100%;margin-right:", ";&:nth-last-child(2){margin-right:0;}cursor:pointer;&:focus,&:active{outline:none;border:none;}"], function (props) {
  return props.gap || 0;
});
var Bar = /*#__PURE__*/_styledComponents["default"].hr.withConfig({
  componentId: "sc-1y3q50z-4"
})(["height:0.2rem;border-color:transparent;border-radius:0.7rem;align-self:center;background-color:", ";transform:", ";width:", ";margin:0.8rem 0 0.1rem 0;will-change:transform;transition:transform 0.25s ", ";z-index:1;", ":first-child &{align-self:flex-start;width:100%;}", ":nth-last-child(2) &{align-self:flex-end;width:", "%;}"], _red["default"].z400, function (props) {
  return props.active ? "none" : "scaleX(0)";
}, function (props) {
  return props.isSpaced ? "100%" : "calc(100% - 3.6rem)";
}, _AnimationsUtil.easings.easeInOutSine, Wrapper, Wrapper, function (props) {
  return props.isSpaced ? 100 : 90;
});
HorizontalTabs.LinkEle = (0, _styledComponents["default"])(_H["default"]).withConfig({
  componentId: "sc-1y3q50z-5"
})(["font-size:", ";line-height:", ";font-weight:", ";margin:", "rem 1rem;border:1px solid transparent;padding:0.5rem 0.8rem;border-radius:6px;white-space:nowrap;:last-child{margin-right:0;}", ":focus &{border-color:", ";}", ":first-child &{margin-left:", ";padding-left:", ";}", ":nth-last-child(2) &{margin-right:", ";padding-right:", ";}&:focus,&:active{outline:none;border-color:transparent;}", ";"], function (props) {
  return props.appearance === "bold" ? _typography.fontSizes.z600 : _typography.fontSizes.z300;
}, _typography.lineHeight.medium, function (props) {
  return props.appearance === "bold" ? _typography.fontWeights.medium : _typography.fontWeights.light;
}, function (props) {
  return props.isSpaced ? 0.3 : 0.7;
}, Wrapper, _red["default"].z400, Wrapper, function (props) {
  return props.isSpaced ? "1rem" : 0;
}, function (props) {
  return props.isSpaced ? "0.8rem" : 0;
}, Wrapper, function (props) {
  return props.isSpaced ? "1rem" : 0;
}, function (props) {
  return props.isSpaced ? "0.8rem" : 0;
}, function (props) {
  return props.active ? (0, _styledComponents.css)(["color:", ";"], _red["default"].z500) : (0, _styledComponents.css)(["color:", ";"], _grey["default"].z700);
});
HorizontalTabs.Link.propTypes = {
  onClick: _propTypes["default"].func,
  active: _propTypes["default"].bool,
  appearance: _propTypes["default"].oneOf(["default", "bold"]),
  isSpaced: _propTypes["default"].bool
};
HorizontalTabs.Link.defaultProps = {
  onClick: function onClick() {},
  active: false,
  appearance: "default",
  isSpaced: false
};
HorizontalTabs.propTypes = {
  alignLinks: _propTypes["default"].oneOf(["center", "left", "right", "even"]),
  /** minimum gap between tabs is 36px (3.6rem), additionalGap adds to it */
  additionalGap: _propTypes["default"].number,
  bottomBorder: _propTypes["default"].bool,
  appearance: _propTypes["default"].oneOf(["default", "bold"]),
  large: _propTypes["default"].bool,
  hasThinLine: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  floatBottom: _propTypes["default"].bool
};
HorizontalTabs.defaultProps = {
  alignLinks: "center",
  additionalGap: "2rem",
  bottomBorder: false,
  appearance: "default",
  large: false,
  hasThinLine: false,
  children: null,
  floatBottom: false
};
var _default = exports["default"] = HorizontalTabs;